import { render, staticRenderFns } from "./CollectionImagesSummary.vue?vue&type=template&id=244e0750&"
import script from "./CollectionImagesSummary.vue?vue&type=script&lang=js&"
export * from "./CollectionImagesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports